var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 36,
    viewBox: "0 0 51 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#E8E8E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6666 25.5V23.8333C24.6666 22.9493 24.3154 22.1014 23.6903 21.4763C23.0652 20.8512 22.2173 20.5 21.3333 20.5H14.6666C13.7825 20.5 12.9347 20.8512 12.3096 21.4763C11.6844 22.1014 11.3333 22.9493 11.3333 23.8333V25.5",
    stroke: "#455674",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0001 17.1667C19.841 17.1667 21.3334 15.6743 21.3334 13.8333C21.3334 11.9924 19.841 10.5 18.0001 10.5C16.1591 10.5 14.6667 11.9924 14.6667 13.8333C14.6667 15.6743 16.1591 17.1667 18.0001 17.1667Z",
    stroke: "#455674",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2832 21.0134C45.8828 21.5177 45.1172 21.5177 44.7168 21.0134L42.0243 17.6218C41.504 16.9664 41.9708 16 42.8075 16H48.1925C49.0292 16 49.496 16.9664 48.9757 17.6218L46.2832 21.0134Z",
    fill: "#455674"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.6053fa81c0dcde389b42d505f46c6774.svg";
export { ForwardRef as ReactComponent };